export var MouseEvent;
(function (MouseEvent) {
  MouseEvent["mousedown"] = "mousedown";
  MouseEvent["wheel"] = "wheel";
  MouseEvent["DOMMouseScroll"] = "DOMMouseScroll";
  MouseEvent["mousewheel"] = "mousewheel";
  MouseEvent["touchmove"] = "touchmove";
})(MouseEvent || (MouseEvent = {}));